import { render, staticRenderFns } from "./RepInscritosNal.vue?vue&type=template&id=3cf069c9&"
import script from "./RepInscritosNal.vue?vue&type=script&lang=js&"
export * from "./RepInscritosNal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports